/** @jsx jsx */

import React, {
  Fragment as _,
  useLayoutEffect,
  useEffect,
  useRef,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { interactionContext } from './interactionContext';
import isIE from 'services/isIE';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const Option = ({ option, isDragging }) => {
  const { id, children } = option;

  const context = useContext(interactionContext);

  const optionContainer = useRef(null);
  const calcHeight = useRef(0);

  const {
    panelBackground = lPink,
    panelBackgroundDragging = lGrey0,
    textColorDragging = '#fff',
  } = context.props;

  useLayoutEffect(() => {
    // remove the chameleon-text class
    // so only responds to local color
    const chameleonText = optionContainer.current.querySelector(
      '.chameleon-text'
    );
    chameleonText && chameleonText.classList.remove('chameleon-text');
  });

  useEffect(() => {
    if (isIE()) {
      const tick = setInterval(() => {
        const height = Math.max(
          optionContainer.current.firstElementChild.scrollHeight,
          55
        );

        optionContainer.current.style.height = `${height + 20}px`;
        if (calcHeight.current === height) {
          clearInterval(tick);
        }

        calcHeight.current = height;
      }, 1000 / 60);
    }
  }, []);

  return (
    <div
      ref={optionContainer}
      id={`sortation-option-${id}`}
      className="sortation-option"
      css={css`
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        ${!isIE() && 'min-height: 55px;'}
        background: ${isDragging ? panelBackgroundDragging : panelBackground};
        margin: 5px 0;
        padding: 5px 10px;
        border-radius: 5px;
        color: ${isDragging ? textColorDragging : ''};
        transition: background 0.3s;

        //double up needed for editing. . .
        * div {
          color: ${isDragging ? textColorDragging : ''};
        }

        h1,
        h2,
        h3,
        p {
          margin: 0;
        }

        ${!window.dev() &&
          `
            user-select: none;
            // pointer-events: none;
        `}
      `}
    >
      {/* {isIE() ? (
        <div
          css={css`
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          `}
        >
          {children}
        </div>
      ) : (
        children
      )} */}

      {children}
      {/* {isIE()
        ? Math.random()
            .toString(16)
            .substr(2, 8)
        : children} */}
    </div>
  );
};

export default Option;
